import { FileText } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface InsightSourceTooltipProps {
  label: string;
  source: string;
}

export function InsightSourceTooltip({ label, source }: InsightSourceTooltipProps) {
  if (!source) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex h-6 w-6 items-center justify-center rounded-full text-gray-500 hover:bg-white/70 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#5E548E]/40"
          aria-label={`Source for ${label}`}
        >
          <FileText className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="end"
        className="max-w-xs text-xs leading-5"
      >
        {source}
      </TooltipContent>
    </Tooltip>
  );
}
